<template>
  <v-app>
    <v-card class="bgs rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <v-container>
        <h2 class="text-center mt-6 font24 mb-4">
          {{ $t("Taoify 用户使用协议") }}
        </h2>
        <p class="content mt-4">
          {{ $t("提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户使用协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。") }}
        </p>
        <p class="content">
          {{ $t("Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify 网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。") }}
        </p>
        <p class="content">
          {{ $t("本协议为《Taoify 服务条款》补充文件，全套文件还包括《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；针对主协议未予以明确的事项，适用本协议约定。") }}
        </p>
        <p class="content">
          {{ $t("除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify消费协议》等为准。") }}
        </p>
        <p class="content">
          {{ $t("完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。") }}
        </p>

        <h3 class="titlee">{{ $t("一、定义") }}</h3>
        <p class="content">
          {{ $t("用户：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织。") }}
        </p>
        <p class="content">
          {{ $t("平台：指Taoify 平台运营主体及平台软硬件系统、网站、服务端口等整体服务载体。") }}
        </p>

        <h3 class="titlee">{{ $t("二、账户注册与使用规范") }}</h3>
        <h4 style="font-size:16px;font-weight:600;color:#555;margin-top:15px;">{{ $t("（一）用户资质与信息管理") }}</h4>
        <p class="content">
          {{ $t("1. 用户注册时，须向平台提交真实、合法、有效的身份信息、注册地址、实际经营地址、联系电话等资料，不得伪造、变造、隐瞒、虚报注册及资质资料。若用户依托本平台开展经营活动，除法律法规明确可不予登记的情形外，必须依法完成市场主体登记，取得有效营业执照，并在登记经营范围内开展业务。经营项目依法需要行政许可、审批、备案、资质认证的，用户须提前取得对应资质并保证资质持续有效，同时将相关文件提交平台留存。若许可资质被撤销、吊销、到期失效，用户须立即停止对应经营活动并同步告知平台，否则视为严重违约，由此产生的全部法律责任、经济损失由用户自行承担；造成平台损失的，用户须足额赔偿。平台依据监管要求中断、终止服务的，已收取费用不予退还。") }}
        </p>
        <p class="content">
          {{ $t("用户须及时完善账户基础信息，因信息错误、失联产生的所有后果，由用户自行负责。用户信息、资质发生变更的，需在变更3个工作日内主动在平台完成更新备案。因资料虚假、失效、未及时更新引发的一切风险与责任，均由用户自行承担。用户需自行妥善保管账户资料、账号、密码等私密信息，不得向无关第三方泄露、转借。因保管不当、信息外泄造成的资金损失、财产损害及法律责任，全部由用户承担。") }}
        </p>

        <h4 style="font-size:16px;font-weight:600;color:#555;margin-top:15px;">{{ $t("（二）平台使用限制") }}</h4>
        <p class="content">
          {{ $t("1. 用户需严格按照所购服务档位的资源限额使用平台服务，超出限制的，平台有权采取限流、关停网站等管控措施，相关损失由用户自行承担，已支付费用不予退还。") }}
        </p>
        <p class="content">
          {{ $t("2. 用户严禁实施以下违规行为：") }}
        </p>
        <ul>
          <li>{{ $t("（1）通过群发垃圾邮件、商业广告等方式推广站点；") }}</li>
          <li>{{ $t("（2）运行违规程序、进程，恶意占用服务器内存、CPU、宽带等资源，造成服务器卡顿、宕机，影响平台及其他用户正常使用；") }}</li>
          <li>{{ $t("（3）发起网络攻击、篡改系统配置、破坏平台网络与信息安全；") }}</li>
          <li>{{ $t("（4）运行干扰服务器正常运行的程序、软件；") }}</li>
          <li>{{ $t("（5）泄露自身及其他客户身份、隐私信息；") }}</li>
          <li>{{ $t("（6）提供、售卖与未成年人相关的违规商品及服务；") }}</li>
          <li>{{ $t("（7）发布、提供带有骚扰、诽谤性质的商品与服务；") }}</li>
          <li>{{ $t("（8）借助平台宣传、售卖基于种族、民族、肤色、宗教信仰等歧视他人、侵犯人权的商品或服务；") }}</li>
          <li>{{ $t("（9）侵犯任何第三方知识产权；") }}</li>
          <li>{{ $t("（10）售卖危险品、管制物品、侵权商品等国内外法律法规明令禁止流通、进出口的商品；") }}</li>
          <li>{{ $t("（11）利用平台开展洗钱、逃税、非法交易等各类违法活动；") }}</li>
          <li>{{ $t("（12）开展超出服务范围及国家法律法规禁止的其他行为。") }}</li>
        </ul>

        <h4 style="font-size:16px;font-weight:600;color:#555;margin-top:15px;">{{ $t("（三）用户基本义务") }}</h4>
        <p class="content">
          {{ $t("数据安全义务：用户须遵守国家数据保护相关法律法规，建立数据安全防护机制，妥善存储、管理平台数据，严禁泄露、篡改、非法使用数据。因用户行为引发数据安全违规的，由用户独立承担全部法律责任。") }}
        </p>
        <p class="content">
          {{ $t("商品与服务合规义务：用户上架、销售、提供的商品及服务，必须符合国家安全、生产、环保等法律法规与行业标准，不得提供存在安全隐患、污染环境、危害公众健康的产品及服务。因商品、服务问题引发投诉、处罚、民事赔偿的，责任由用户全部承担。平台收到投诉后，可根据情节采取警示、下架商品、删除内容、暂停服务、封禁账号等处置措施。") }}
        </p>
        <p class="content">
          {{ $t("税务与票据义务：用户开展经营活动须依法纳税，如实申报税费，按规定向交易方开具正规发票，严禁偷税、漏税、逃税、虚开发票、拒开发票，不得参与走私、变相避税等违法活动。平台有权核验票据及纳税凭证，用户违规的，平台可暂停或终止全部服务。") }}
        </p>
        <p class="content">
          {{ $t("信息发布义务：用户发布内容需严格遵守法律法规，不得制作、复制、发布、传播违法违规、损害公共利益及他人合法权益的信息，不得为违规内容提供跳转、链接等便利。用户收到平台整改通知后须立即整改；拒不整改的，平台有权暂停或终止全部服务。因用户或其客户发布违规内容造成平台损失的，由客户、用户承担全部赔偿责任。") }}
        </p>
        <p class="content">
          {{ $t("个人信息保护义务：用户收集、使用、存储、传输客户个人信息，需严格遵守法律法规，严禁非法收集、泄露、出售、篡改他人隐私信息。若发生信息泄露、侵权事件，用户承担全部民事、行政及刑事责任。") }}
        </p>
        <p class="content">
          {{ $t("知识产权保护义务：用户在平台上传、发布的文字、图片、视频、商标、设计等内容，需拥有知识产权或取得权利人授权，不得侵犯第三方著作权、商标权、专利权等合法权益。用户因侵权引发投诉、诉讼、索赔、行政处罚的，赔偿金、诉讼费、律师费、罚款等所有费用由用户承担，同时用户需赔偿平台方直接、间接损失。") }}
        </p>
        <p class="content">
          {{ $t("账号安全义务：用户全权负责账号、站点内容、登录密码的安全保管，因账号外泄、保管不当造成的损失，由用户自行承担。用户需向平台报备对接人员及联系方式，相关人员行为产生的后果由用户承担。") }}
        </p>
        <p class="content">
          {{ $t("平台知识产权约定：平台所有技术资料、软件、系统、技术服务的知识产权均归 Taoify 平台所有，用户不得擅自复制、传播、转让、授权第三方使用，违者承担相应法律责任。") }}
        </p>
        <p class="content">
          {{ $t("服务使用规则：站点开通后，用户须及时登录会员中心完成基础配置。用户可同时订购多项平台服务，各项服务周期自购买当日起计算，服务期内不支持暂停。") }}
        </p>
        <p class="content">
          {{ $t("订单履约义务：用户收到平台警告后须及时优化发货效率、完成整改，长期拒不整改的，平台有权单方面终止服务。") }}
        </p>
        <p class="content">
          {{ $t("投诉处置规则：若平台收到第三方针对用户发布内容、在售商品、提供服务、隐私侵权、知识产权侵权、违法违规等投诉或实名举报，平台有权不经用户同意，直接对用户相关内容、页面、商品、链接进行删除、屏蔽、下架处理；情节严重、拒不整改的，平台可直接暂停、终止全部服务，用户已缴纳的所有费用不予退还。") }}
        </p>

        <h3 class="titlee">{{ $t("三、服务费用、续费与佣金") }}</h3>
        <p class="content">
          {{ $t("本平台服务价格以 Taoify 平台官网、购买页面实时公示为准，用户须按约定方式、期限足额支付费用；未付清费用前，Taoify 平台有权暂停、终止提供服务。") }}
        </p>
        <p class="content">
          {{ $t("平台赠送服务、优惠活动均为一次性福利，赠送服务不包含修改、更新、维护费用，亦不得折价抵扣服务费，赠送服务最终解释权归 Taoify 平台所有。") }}
        </p>
        <p class="content">
          {{ $t("服务期限届满前用户未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。") }}
        </p>
        <p class="content">
          {{ $t("若用户实际交易额超出对应产品套装免佣额度，超出部分用户须按约定支付佣金。佣金按单笔实时扣除或自然月统一核算，用户收到账单后5个工作日内完成支付；逾期未支付的，Taoify 平台有权终止服务。") }}
        </p>
        <p class="content">
          {{ $t("用户有权要求 Taoify 平台就实付服务费用开具正规发票，赠送服务对应的金额不纳入开票范围。") }}
        </p>

        <h3 class="titlee">{{ $t("第四条 服务终止") }}</h3>
        <p class="content">
          {{ $t("服务期内用户主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。") }}
        </p>
        <p class="content">
          {{ $t("因系统停机、升级、维护；电信线路、设备故障，银行系统异常等第三方问题造成服务中断、卡顿、故障的，Taoify 平台不承担责任。") }}
        </p>
        <p class="content">
          {{ $t("因用户原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。") }}
        </p>
        <p class="content">
          {{ $t("网络拥堵；黑客攻击、电信故障、政府管制、不可抗力、第三方原因等非 Taoify 平台原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。") }}
        </p>
        <p class="content">
          {{ $t("用户违规占用资源、发布违法信息、侵权、泄露隐私、违法经营、拒不整改等违反本协议约定的，Taoify 平台有权立即关闭网站、终止服务、冻结账号，余款不予退还，同时用户须赔偿 Taoify 平台全部损失，包括但不限于直接损失、间接损失、律师费等。") }}
        </p>
        <p class="content">
          {{ $t("因用户使用第三方服务导致网站故障、无法使用的，Taoify 平台不承担任何责任。") }}
        </p>
        <p class="content">
          {{ $t("Taoify平台无需就用户遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。") }}
        </p>
        <p class="content">
          {{ $t("若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。") }}
        </p>

        <h3 class="titlee">{{ $t("第五条 知识产权与平台内容约定") }}</h3>
        <p class="content">
          {{ $t("Taoify平台全部内容，包括但不限于文字、图片、文档、资讯、网站架构、界面设计、程序代码等，相关商标权、著作权、专利权、商业秘密等知识产权均归Taoify平台所有。未经 Taoify 平台书面许可，任何主体不得擅自使用、复制、修改、传播、分发平台内容及程序。") }}
        </p>
        <p class="content">
          {{ $t("用户仅可在 Taoify平台指定专属服务器内使用本平台搭建的网站，不得将网站迁移至非本平台、非本平台提供的服务器运行。") }}
        </p>
        <p class="content">
          {{ $t("用户自行在网站创建、上传的内容，由用户独立承担全部法律责任；基于本平台开发的第三方应用，其行为、内容、数据由第三方自行负责，Taoify 平台不承担连带责任。") }}
        </p>

        <h3 class="titlee">{{ $t("第六条 条款修订") }}</h3>
        <p class="content">
          {{ $t("Taoify平台有权随时修订本协议条款、服务定价，协议条款修订提前1个工作日在平台公示，资费调整提前1个月公示。修订后的条款公示后继续使用服务的，视为用户自愿接受全部修订内容。") }}
        </p>

        <h3 class="titlee">{{ $t("第七条 通知") }}</h3>
        <p class="content">
          {{ $t("用户确认，在 Taoify平台注册所提供的身份信息、地址、联系方式为本协议履行、相关的诉讼、仲裁程序中的法定送达地址及送达方式，司法机关可直接据此送达各类司法文书。双方均同意以邮寄、电子送达方式收取司法文书。上述送达地址及方式的效力涵盖仲裁、一审、二审、再审及执行等全部诉讼阶段。若一方信息变更，需提前3个工作日申请变更，未变更的，原约定地址及方式仍视为有效送达地址，任何一方、司法机关按原地址送达即便被退回，也视为有效送达。") }}
        </p>

        <h3 class="titlee">{{ $t("第八条 不可抗力") }}</h3>
        <p class="content">
          {{ $t("不可抗力指战争、武装冲突、自然灾害（如地震、洪水）、罢工、暴乱、政府行为（如禁令、制裁）、司法限制、全国性疫情等不能预见、不能避免且不能克服的客观事件。") }}
        </p>

        <h3 class="titlee">{{ $t("第九条 其他约定") }}</h3>
        <ul>
          <li>{{ $t("1. Taoify平台发生上市、收购、合并、名称变更等情形时，有权将本协议项下全部权利、义务转移给权利义务承接方，用户对此无异议。") }}</li>
          <li>{{ $t("2. Taoify 平台内服务说明、价格公示、申请表格等文件，均为本协议不可分割的组成部分，与本协议具有同等法律效力。") }}</li>
          <li>{{ $t("3. 若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("第十条 争议解决") }}</h3>
        <p class="content">
          {{ $t("1. 平台有关条款（包括但不限于本使用协议等）可能会有除中文以外的其他版本。如果不同语言版本的使用协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本使用协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本使用协议，予以明确排除。") }}
        </p>
        <p class="content">
          {{ $t("2. 因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。") }}
        </p>
        <p class="content">
          {{ $t("争议处理期间，除争议事项外，双方应继续履行本协议其他约定。本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。") }}
        </p>

        <p class="content">
          {{ $t("本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本协议更新日期：2026年1月1日。") }}
        </p>
        <p class="content">
          © {{ year }} Taoify · 香港星橋國際貿易有限公司 · 版权所有
        </p>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
export default { data() { return { year: new Date().getFullYear() }; } };
</script>

<style lang="scss" scoped>
.titlee {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 25px;
  margin-top: 25px;
  margin-bottom: 10px;
}
.content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
}
li {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
  margin-left: 20px;
  list-style: initial;
}
</style>
